<template>
  <import-csv v-model="showImport" type="products for batch move" :fields="importFields" importAction="productsBulkMoveImport" :instructions="instructions" @refresh="$emit('refresh')"/>
</template>

<script>
export default {
  name: 'InventoryProductsBulkMoveImport',
  props: {
    value: {type:Boolean,required:true}
  },
  data() {
    return {
      showImport: this.value,
      importFields: [{name:'Date',mapTo:'',mandatory:true,date:true},
                     {name:'Product',mapTo:'',mandatory:true},
                     {name:'In-bond',mapTo:'',mandatory:true},
                     {name:'Lot',mapTo:'',mandatory:true},
                     {name:'From site',mapTo:'',mandatory:false},
                     {name:'To site',mapTo:'',mandatory:false},
                     {name:'To duty-paid',mapTo:'',mandatory:true},
                     {name:'Cases',mapTo:'',mandatory:true},
                     {name:'Bottles',mapTo:'',mandatory:true},
                     {name:'Comments',mapTo:'',mandatory:false}
                     ],
      instructions: `<ol class="mb-4">
                        <li>Date</li>
                        <li>Product (SKU or name)</li>
                        <li>Move in-bond product? (1 or 0)</li>
                        <li>Lot</li>
                        <li>From site (optional)</li>
                        <li>To site (optional)</li>
                        <li>Move to duty-paid? (1 or 0)</li>
                        <li>Cases to move</li>
                        <li>Bottles to move</li>
                        <li>Comments</li>
                      </ol>`
    }
  },
  watch: {
    value() {
      this.showImport = this.value;
    },
    showImport() {
      this.$emit('input', this.showImport);
    }
  },
  methods: {
    doImport() {
      this.$refs.import.doImport();
    },
  }
}
</script>
